import React from "react";
import Fullscreen from "react-full-screen";
const FullscreenContext = React.createContext<React.MutableRefObject<Fullscreen | null> | null>(null);

export default FullscreenContext;
